import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { trackEvent } from '@/utils/analytics/useAnalytics'
import { useDispatch } from 'react-redux'

import { Box, Divider } from '@chakra-ui/react'

import { IncidentIcon, QuickReportIcon } from '@/components/icons'
import { ButtonTag, IncidentDescription } from '@/components/ui'
import { IncidentQuery } from '@/graphql/generated/operations'
import { IncidentSource } from '@/graphql/generated/schemas'
import {
  closeSOPIncidentDrawer,
  toggleIncidentTraceLogDrawer,
} from '@/redux/ui/uiSlice'
import { BUTTON_PRESS } from '@/utils/analytics'

import {
  VIEW_TL_EVENT,
  getMixpanelEventData,
} from '../../trace-log-drawer/utils/utils'
import { MixpanelDataIProps } from '../../types/types'
import { shouldShowTraceLogs } from '../utils/utils'
import { FeedButtons } from './FeedButtons'
import { FeedItem } from './FeedItem'
import { IncidentHeader } from './IncidentAction'
import { QuickReportDetail } from './QuickReportDetail'

interface IncidentDetailsIProps {
  incident?: IncidentQuery['incident']
  mixpanelData?: MixpanelDataIProps
}

export const IncidentDetails = ({
  incident,
  mixpanelData,
}: IncidentDetailsIProps) => {
  const dispatch = useDispatch()
  const device = incident?.devices[0]
  const source = incident?.source
  const { traceLogs: isTraceLogsEnabled } = useFeatureFlags()

  const openTraceLogDrawer = () => {
    dispatch(closeSOPIncidentDrawer())
    dispatch(toggleIncidentTraceLogDrawer())
    const mixpanelData = getMixpanelEventData(incident)
    trackEvent(`${BUTTON_PRESS} ${VIEW_TL_EVENT}`, mixpanelData)
  }
  return (
    <Box>
      <FeedItem
        actionType={incident?.status}
        createdAt={incident?.createdAt}
        heading={IncidentHeader(incident?.name, incident?.status)}
        icon={
          source === IncidentSource.QuickReport ? (
            <QuickReportIcon />
          ) : (
            <IncidentIcon
              incidentType={incident?.type}
              name={incident?.name}
              size={30}
            />
          )
        }
      >
        <IncidentDescription
          creator={incident?.creator}
          description={incident?.description}
          deviceId={device?.id}
          deviceName={device?.name}
          deviceType={device?.type}
          floorId={incident?.floor?.id}
          floorName={incident?.floor?.name}
          manualIncidentCategoryName={incident?.manualIncidentCategory?.name}
          name={incident?.name}
          type={incident?.type}
        />
        {isTraceLogsEnabled && shouldShowTraceLogs(incident?.type) && (
          <ButtonTag
            mt='10px'
            onClick={openTraceLogDrawer}
            style={{
              padding: '3px 20px',
            }}
          >
            View Trace Logs
          </ButtonTag>
        )}

        {source === IncidentSource.QuickReport && (
          <QuickReportDetail
            detail={incident?.externalDetail}
            incidentCategory={incident?.manualIncidentCategory?.name}
          />
        )}
      </FeedItem>

      <FeedButtons incident={incident} mixpanelData={mixpanelData} />

      <Divider borderColor='#DFE3EF' my='20px' w='100%' />
    </Box>
  )
}
